import { WidgetRegistry, IBuildWidgets, EWidgetType } from "../../sg-schema/utils/widgetRegistry";
import commonSGWriteWidgets from "../../sg-schema/themes/semantic/widgets";
import commonSGReadWidgets from "../../sg-schema/themes/semantic-display/widgets";

import { ThemeProps, withTheme, WidgetProps } from "@rjsf/core";
import { withRules } from "../../sg-schema/withRules";
import commonhavainnotWriteWidgets from "../components/form/jsonSchemaWidgets/write";
import commonhavainnotReadWidgets from "../components/form/jsonSchemaWidgets/read";

import writeFields from "../components/form/jsonSchemaFields/write";
import readFields from "../components/form/jsonSchemaFields/read";

export class JsonSchemaConfiguration {
    private _widgetRegistry = WidgetRegistry.create();
    private built = false;

    private _themes: { [type in EWidgetType]?: ThemeProps } = {};

    private _widgets?: IBuildWidgets;

    public get widgets(): IBuildWidgets {
        if (!this._widgets) {
            throw new Error("Cannot get widgets from Schema configuration: Widgets have not been built");
        }
        return this._widgets;
    }

    public getForm(type: EWidgetType) {
        const theme = this._themes[type];
        if (!theme) {
            throw new Error(`Cannot get theme for form type '${type}': Theme not configured`);
        }

        const completeTheme = {
            ...theme,
            fields: type === EWidgetType.Read ? { ...theme.fields, ...readFields } : { ...theme.fields, ...writeFields },
            widgets: type === EWidgetType.Read ? this._widgets?.read : this._widgets?.write
        };

        return withRules(withTheme(completeTheme));
    }




    public addDefaultWidgets() {
        this._widgetRegistry.appendWidgets(EWidgetType.Read, commonSGReadWidgets);
        this._widgetRegistry.appendWidgets(EWidgetType.Write, commonSGWriteWidgets as any);

        this._widgetRegistry.appendWidgets(EWidgetType.Read, commonhavainnotReadWidgets);
        this._widgetRegistry.appendWidgets(EWidgetType.Write, commonhavainnotWriteWidgets);

    }

    public addWidget(name: string, writer: React.ComponentType<WidgetProps>, reader: React.ComponentType<WidgetProps>) {
        this._widgetRegistry.addWidget(EWidgetType.Write, name, writer);
        this._widgetRegistry.addWidget(EWidgetType.Read, name, reader);
    }

    public addTheme(type: EWidgetType, theme: ThemeProps) {
        this._themes[type] = theme;
    }

    public build() {
        if (this.built) {
            throw new Error("Cannot build JsonSchemaConfiguration: Configuration already built");
        }
        this._widgets = this._widgetRegistry.build();
        this.built = true;
    }
}